/**
 * Accedo OVP
 * API version: 1.2.0
 *
 * NOTE: This class was automatically generated by Swagger Code Generator. Do not edit it manually.
 */
'use strict';

var ApiClient = require('../ApiClient');
var Category = require('./Category');
var Content = require('./Content');
var Credit = require('./Credit');
var Image = require('./Image');
var Media = require('./Media');
var Metadata = require('./Metadata');
var ParentalRating = require('./ParentalRating');




  /**
   * The Episode model module.
   * @module model/Episode
   * @version 1.4.0
   */

  /**
   * Constructs a new <code>Episode</code>.
   * @alias module:model/Episode
   * @class
   * @extends module:model/Media
   */
  var exports = function() {
    var _this = this;
    Media.call(_this);
  };

  /**
   * Constructs a <code>Episode</code> from a plain JavaScript object, optionally creating a new instance.
   * Copies all relevant properties from <code>data</code> to <code>obj</code> if supplied or a new instance if not.
   * @param {Object} data The plain JavaScript object bearing properties of interest.
   * @param {module:model/Episode} obj Optional instance to populate.
   * @return {module:model/Episode} The populated <code>Episode</code> instance.
   */
  exports.constructFromObject = function(data, obj) {
    if (data) {
      obj = obj || new exports();
      Media.constructFromObject(data, obj);
    }
    return obj;
  };

  exports.prototype = Object.create(Media.prototype);
  exports.prototype.constructor = exports;








module.exports = exports;